import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import PortfolioConfirmDialog from "@/components/PortfolioConfirmDialog";
import { useAuth } from "@/context/AuthContext";

export const AutoLinkAllButton = ({ partyType = "client", onDone }) => {
  const { hasPermission } = useAuth();
  const [busy, setBusy] = useState(false);
  const [confirm, setConfirm] = useState(null);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/contracts/auto-link-all?party_type=${partyType}`);
      toast.success(`${data.linked} facture(s) liée(s) sur ${data.contracts_touched} contrat(s)`
        + (data.linked_multi ? ` dont ${data.linked_multi} partagée(s) entre plusieurs contrats` : "")
        + (data.to_confirm_count ? ` · ${data.to_confirm_count} à confirmer` : ""));
      if (data.to_confirm?.length) setConfirm(data);
      else onDone?.();
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };

  if (!hasPermission("contracts.write")) return null;
  return (
    <>
      <Button onClick={run} disabled={busy} className="bg-blue-600 hover:bg-blue-700"
              data-testid="contracts-auto-link-all-btn">
        {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Sparkles className="h-4 w-4 mr-2" />}
        {busy ? "Liaison en cours…" : "Lier toutes les factures"}
      </Button>
      {confirm && (
        <PortfolioConfirmDialog data={confirm} onClose={() => { setConfirm(null); onDone?.(); }} />
      )}
    </>
  );
};
